import md5 from 'md5';
import { get, post } from '../api/_basic';

class ManageProcessApi {
    static async processFamilies(json) {
        try {
            if (json.data === undefined) return json;
            const processes = json.data;

            const families = processes.reduce((arr, process) => {
                const elements = processes.reduce((items, p) => {
                    if (p.familia === process.familia) {
                        p.status = 'origin';
                        items.push(p);
                    }
                    return items;
                }, []);
                arr[process.familia] = {
                    codigo: md5(process.familia),
                    nombre: process.familia,
                    processes: elements,
                    status: 'origin',
                };
                return arr;
            }, {});

            return {
                families: Object.keys(families).map(function(i) {
                    return families[i];
                }),
                modified: false,
            };
        } catch (error) {
            console.log('error: ' + error);
            return { error: error };
        }
    }

    static async launch(processCode, local, employee) {
        try {
            let body = [{ codigo: 'LOCAL', valor: local }];
            if (!!employee) {
                body = [
                    { codigo: 'LOCAL', valor: local },
                    { codigo: 'TRABAJADOR', valor: employee },
                ];
            }
            return await post(process.env.REACT_APP_API_INSTANCE + '/' + processCode, {
                campos: body,
            });
        } catch (error) {
            return { error: error };
        }
    }

    static async get() {
        try {
            const response = await get(process.env.REACT_APP_API_MANAGE_PROCESS);
            return await ManageProcessApi.processFamilies(response);
        } catch (error) {
            return error;
        }
    }

    static async postForm(data) {
        try {
            const body = {
                proceso: data.codigo,
                codigo: data.codigo + '-form',
                nombre: data.nombre,
                descripcion: '',
                alto: 0,
                ancho: 0,
                centrado: false,
                puntuacion: 0,
                sistema: false,
                metadatos: null,
                permisos: data.permisos,
            };

            return await post(process.env.REACT_APP_API_MANAGE_FORM + '/' + data.codigo, body);
        } catch (error) {
            return { error: error };
        }
    }

    static async duplicate(
        codigo,
        name,
        _new,
        idCliente,
        rules,
        programming,
        programmingfields,
        clonarpermisos,
    ) {
        try {
            const body = {
                codigoDestino: _new,
                nombreDestino: name,
            };

            if (idCliente) {
                body.clienteDestino = idCliente;
            }
            if (rules) {
                body.clonarreglas = rules;
            }
            if (programming) {
                body.clonarprogramacion = programming;
            }
            if (programmingfields) {
                body.clonarprogramacioncampos = programmingfields;
            }
            if (clonarpermisos) {
                body.clonarpermisos = true;
            }
            return await post(
                process.env.REACT_APP_API_MANAGE_PROCESS + '/' + codigo + '/clonar',
                body,
            );
        } catch (error) {
            return { error: error };
        }
    }

    static async postState(data, name, final) {
        try {
            const body = {
                proceso: data.codigo,
                codigo: name,
                nombre: name,
                descripcion: '',
                permisos: data.permisos,
                inicial: !final,
                final: final,
                ttl: 0,
                metadatos: null,
                formulario: data.codigo + '-form',
            };
            return await post(process.env.REACT_APP_API_MANAGE_STATE + '/' + data.codigo, body);
        } catch (error) {
            return { error: error };
        }
    }

    static async postTransition(data) {
        try {
            const body = {
                proceso: data.codigo,
                codigo: 'finalizar',
                nombre: 'Finalizar',
                estadoinicial: 'ejecutar',
                estadofinal: 'fin',
                descripcion: '',
                timeout: false,
                puntuacionminima: 0,
                confirmartexto: null,
                comentarioavancetexto: null,
            };
            return await post(process.env.REACT_APP_API_TRANSITIONS + '/' + data.codigo, body);
        } catch (error) {
            return { error: error };
        }
    }
}

export default ManageProcessApi;



// WEBPACK FOOTER //
// ./src/api/ManageProcessApi.js